import { t } from "i18next";

const twoFactorSendType = [
    {
        id: 1,
        name: "SMS",
    },
    {
        id: 2,
        name: t("Email"), 
    },
    // {
    //     id: 50,
    //     name: "",
    // },
//    {
//        id: 0,
//        name: t("None"),
//    },
];

export const NOTIFICATION_METHOD_DROPDOWN =twoFactorSendType 